module.exports = __webpack_public_path__ + "static/media/_Hebrock_brochure_F_series_en.d3972397.pdf";